var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "d-flex flex-row align-items-start",
      staticStyle: { gap: "10px" },
    },
    [
      _c(
        "div",
        {
          staticClass: "trt-cart-wrapper",
          style: _vm.kmzLoading ? { minHeight: "120px" } : {},
        },
        [
          _vm.kmzLoading
            ? _c(
                "div",
                { staticClass: "kmz-loading-overlay" },
                [
                  _c("b-spinner", {
                    attrs: { variant: "light", label: "Loading..." },
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "kmz-loading-text" }, [
                    _vm._v(
                      _vm._s(_vm.kmzLoadingDone) +
                        " / " +
                        _vm._s(_vm.kmzLoadingTotal) +
                        " loaded"
                    ),
                  ]),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "trt-cart",
              class: { "kmz-blurred": _vm.kmzLoading },
              attrs: { id: "cart" },
            },
            [
              _c(
                "b-row",
                {
                  staticClass: "w-100 trt-cart-header px-3 py-2",
                  attrs: { "no-gutters": "" },
                },
                [
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex justify-content-center align-items-center",
                      attrs: { cols: "2" },
                    },
                    [
                      _c("fa", {
                        staticClass: "trt-header-icon",
                        attrs: { icon: ["fas", "shopping-cart"], size: "sm" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass:
                        "d-flex justify-content-start align-items-center pl-2",
                      attrs: { cols: "9" },
                    },
                    [
                      _c("span", { staticClass: "trt-header-label" }, [
                        _vm._v(
                          _vm._s(_vm.cart.length) +
                            " Trail" +
                            _vm._s(_vm.cart.length == 1 ? "" : "s") +
                            " Selected"
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.cart.length
                    ? _c(
                        "b-col",
                        {
                          staticClass:
                            "col-sm-1 d-flex justify-content-center align-items-center",
                        },
                        [
                          _c("fa", {
                            staticClass: "float-right clickable",
                            attrs: {
                              title: _vm.cartMinimized
                                ? "Maximize Cart"
                                : "Minimize Cart",
                              "b]": "",
                              icon: [
                                "fas",
                                _vm.cartMinimized
                                  ? "window-maximize"
                                  : "window-minimize",
                              ],
                              size: "sm",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleCartSize()
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm._v(" "),
              _vm.cart.length && !_vm.cartMinimized
                ? _c(
                    "div",
                    {
                      staticClass:
                        "d-flex flex-column w-100 px-3 py-2 trt-cart-items",
                    },
                    _vm._l(_vm.cart, function (cartItem, index) {
                      return _c(
                        "div",
                        {
                          key: cartItem.pc_id,
                          staticClass:
                            "w-100 d-flex justify-content-center align-items-center flex-row trt-cart-row",
                          on: {
                            mouseover: function ($event) {
                              _vm.cartHoverIndex = index
                            },
                            mouseleave: function ($event) {
                              _vm.cartHoverIndex = null
                            },
                          },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "trt-cart-item w-100 text-truncate",
                              attrs: {
                                id: "cart-" + cartItem.pc_id,
                                size: "sm",
                                variant: "transparent",
                                title: cartItem.pc_id,
                              },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(cartItem.pc_id) +
                                  "\n        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.cartHoverIndex == index
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center ml-1 trt-remove-wrap",
                                },
                                [
                                  _c("fa", {
                                    staticClass: "trt-remove-btn",
                                    attrs: { icon: ["fas", "trash"] },
                                    on: {
                                      click: function ($event) {
                                        return _vm.removeCartItem(cartItem)
                                      },
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.cart.length && !_vm.cartMinimized
                ? _c(
                    "b-row",
                    {
                      staticClass: "w-100 trt-actions px-2 pb-2",
                      attrs: { "no-gutters": "" },
                    },
                    [
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center",
                          attrs: { cols: "10" },
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "trt-stats-btn w-100",
                              attrs: {
                                disabled: _vm.cart.length < 1,
                                title: "Show statistics for selected trails",
                                id: "lidarStatsBtn",
                              },
                              on: { click: _vm.initStatsModal },
                            },
                            [
                              _c("fa", {
                                staticClass: "mr-2",
                                attrs: { icon: ["fas", "chart-bar"] },
                              }),
                              _vm._v("\n          Show Statistics\n        "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        {
                          staticClass:
                            "d-flex justify-content-center align-items-center",
                          attrs: { cols: "2" },
                        },
                        [
                          _c("fa", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.cart.length >= 1,
                                expression: "cart.length >= 1",
                              },
                            ],
                            staticClass: "trt-clear-btn",
                            attrs: {
                              icon: ["fa", "trash"],
                              size: "1x",
                              title: "Clear Selection",
                              id: "clearTrailsBtn",
                            },
                            on: { click: _vm.clearCart },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _vm.showTrailsPanel
        ? _c("TRT_StatisticsWindow", {
            attrs: {
              polygons: _vm.polygons,
              lidar_wkt: _vm.lidar_wkt,
              selectedExtent: _vm.selectedExtent,
              user: _vm.user,
              lidarFlag: _vm.lidarFlag,
              cart: _vm.cart,
              selectedTrails: _vm.selectedTrails,
              map: _vm.map,
            },
            on: {
              removePolygons: function ($event) {
                return _vm.$emit("removePolygons")
              },
              clearCart: function ($event) {
                return _vm.$emit("clearCart")
              },
              notification: function ($event) {
                return _vm.$emit("notification", $event)
              },
              "admin-notification": function ($event) {
                return _vm.$emit("admin-notification", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }